import { graphql } from 'gatsby';
import HtmlParser from 'html-react-parser';
import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import Helmet from 'react-helmet';
import ReactPlayer from 'react-player';
import { Link } from 'react-scroll';
import { DemoFormLongNoSize } from '../../components/DemoFormLongNoSize.jsx';
import MultimedialPanel from '../../components/MultimedialPanel';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';
import '../../scss/pages/_connect.scss';

class Testimonials extends React.Component {

	render() {
		const json = this.props.testimonial;
		//tesimonials.json and testimonialContent must have people in the same order.
		const testimonialContent = [
			//Shelby Wolpa
			<p className="testimonialText">Being able to visualize our org chart on ChartHop by any dimension (department, time zone, gender, squad) has empowered my team to make more <strong>strategic people decisions.</strong> <br/> Plus, the org chart being fully integrated with our HRIS makes for <strong>seamless updates</strong> and zero manual work for my team.</p>,
			//David Politis
			<p className="testimonialText">ChartHop is the perfect product in a world where <strong>remote</strong> work is the standard, where building <strong>diverse</strong> teams is critical and being <strong>agile</strong> as a business is the only way to <strong>thrive.</strong></p>,
			//David Dankenbrink
			<p className="testimonialText">I <strong>can't imagine</strong> what we'd do without ChartHop.<br/>With the auto-updated org chart, custom reporting, and real-time scenario-building, ChartHop has been a <strong>critical tool</strong> in my organization's succession planning and data comprehension.</p>,
			//Jordan Wan
			<p className="testimonialText">I’m in ChartHop almost everyday.<br/>Having an <strong>accurate, single source</strong> of employee data empowers better management decisions and employee transparency.<br/><strong>ChartHop reduces the operational hurdle</strong> of the dreaded annual planning process, allowing us to make <strong>more thoughtful personnel decisions</strong> throughout the year.</p>,
			//Alex Koykova
			<p className="testimonialText">ChartHop helped us <strong>centralize</strong> over a hundred headcount planning spreadsheets into a single platform.<br/>Now we can easily monitor people’s access, progress and consolidate multiple plans with a couple of clicks.
			</p>
		]
		return (
			<Carousel controls={true}>
				{json.map((edge,index) => (
					<Carousel.Item key={edge.node.name} >
						<div className="carouselWrapper row" >
							<div className="carImageContain desktopHeadshot text-sm-center text-md-center">
								<img src={edge.node.image} alt="Author" />
							</div>
							<div className="carouselContent">
								<img src={'/home/quote.svg'} alt="" className="pb-1 pb-sm-2" />
								{testimonialContent[index]}
								<div className="div-display">
									<div className="testimonialAuthorContain" >
										<div className="carImageContain mobileHeadshot  text-center">
											<img src={edge.node.image} alt="Author" />
										</div>
										<div className="p-direction">
											<p className="testimonialAuthor mt-3">{edge.node.name}</p>
											<p className="testimonialAuthorTitle">{edge.node.title}</p>
										</div>
									</div>
									<div className="img-logo-container">
										<img src={edge.node.logo} />
									</div>
								</div>
							</div>
						</div>
					</Carousel.Item>
				))}
			</Carousel>
		);
	}
}

const Home = (props) => {
	const json = props.data.allTestimonialsJson.edges;

	// function shuffle(array) {
	// 	array.sort(() => Math.random() - 0.5);
	// }
	// shuffle(json);

	const location = props.location;

	return (
		<Layout bodyClass="connect" ontouchstart>
			<SEO title="ChartHop Connect | ChartHop | The Org Management Platform" />
			<Helmet>
				<meta name="description" content="Stop spending developer resources on HRIS integrations. Seamlessly integrate into every platform - from ADP and Namely to Workday and Ultipro."/>
				<meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
				<meta property="og:title" content="ChartHop Connect | ChartHop | The Org Management Platform" />
				<meta property="og:description" content="Stop spending developer resources on HRIS integrations. Seamlessly integrate into every platform - from ADP and Namely to Workday and Ultipro." />
				<meta property="og:image" content={`/landings/connect.gif`} />
				<meta property="og:type" content="website" />
				<meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
				{/* Twitter Card tags */}
				<meta name="twitter:title" content="ChartHop Connect | ChartHop | The Org Management Platform" />
				<meta name="twitter:description" content="Stop spending developer resources on HRIS integrations. Seamlessly integrate into every platform - from ADP and Namely to Workday and Ultipro." />
				<meta name="twitter:image" content={`/landings/connect.gif`} />
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
			</Helmet>

			{/* HERO CONTENT */}
			<section className="intro container">
				<div className="row align-items-center">
					<div className="col-md-6 p-xs-2 mb-3 mb-md-0 pr-md-2 pr-lg-4">
						<div className="pretitle">For developers</div>
						<h1>Focus on what matters most - your product.</h1>	
						<p>And leave the time-consuming integrations to us.</p>	
						<div>	
							<Link to="request-demo" smooth={true} offset={-70} duration={500} class="button primary">REQUEST ACCESS</Link>	
						</div>						
					</div>
					<div className="reactPlayerContainer col-md-6 col-lg-6 order-md-1" >
						<ReactPlayer
							url="/landings/connect-07.mp4"
							playing
							loop
							muted
							playsinline
						/>
					</div>
				</div>
			</section>			
			
			{/* THE SOLUTION */}
			<section className="the-solution backgroundGradientContainer">
				<div className="container pt-3 pt-md-5 pb-5  ">

			
					{/* Streamline */}
					<div name="streamline" id="streamline" className="contentBlock">
						<MultimedialPanel 
							multimediaPosition="left"
							link="/product/people-analytics/Integration_reports-2.mp4"
							type="video"
							paddingClass="padding-top-video-1"
							title="Streamline onboarding and data maintenance"
							content={
								<React.Fragment>									
									<p>Seamlessly integrate into your customers' HRIS or PEO - without spending developer resources.</p>
									<p>Automatically update customers' rosters as new employees join, depart or change roles.</p>
								</React.Fragment>
							}
						/>
					</div>

					{/* Improve */}
					<div name="improve" id="improve" className="contentBlock">
						<MultimedialPanel 
							multimediaPosition="right"
							link="/landings/chartHop-connect-value2.png"
							type="image"
							paddingClass="padding-top-video-2"
							title="Improve customer retention"
							content={
								<React.Fragment>									
									<p>Enhance customer success operations with deep understanding of account activity and engagement.</p>
									<p>Surface your value to customers through powerful visuals.</p>
								</React.Fragment>
							}
						/>
					</div>

					{/* Surface */}
					<div name="surface" id="surface" className="contentBlock">
						<MultimedialPanel 
							multimediaPosition="left"
							link="/landings/chartHop-connect-value3.png"
							type="image"
							paddingClass="padding-top-video-3"
							title="Surface compelling trends across your customer base"
							content={
								<React.Fragment>									
									<p>See your aggregated customer data through additional demographic or organizational data you don't collect.</p> 
									<p>Publish marketing content with compelling trends and drive product strategy with data-driven insights. 
									</p> 									
								</React.Fragment>
							}
						/>
					</div>

				</div>
			</section>

			{/* AS FEATURED IN */}
			<section className="customer testimonial-container">
				<div className="container pt-6 pb-5">
					<div className="row align-items-center">
						<div className="col-md-12 text-center">
							<h2 className="text-center">As featured in</h2>
							<div className="d-flex flex-wrap  justify-content-center customer-logos-1">
								<a className="p-xs-1 p-sm-1 m-xs-1 m-sm-1 p-2 " href="https://www.protocol.com/org-chart-startup-linkedin" target="_blank" rel="noopener noreferrer"><img src='/home/brand_logos/protocol-logo.svg' alt="Protocol" /></a>
								<a className="p-xs-1 p-sm-1 m-xs-1 m-sm-1 p-2 " href="https://techcrunch.com/2020/02/20/charthop-grabs-5m-seed-led-by-a16z-to-automate-the-org-chart/" target="_blank" rel="noopener noreferrer"><img src='/home/brand_logos/techcrunch-logo.svg' alt="TechCrunch" /></a>
								<a className="p-xs-1 p-sm-1 m-xs-1 m-sm-1 p-2 " href="https://a16z.com/2020/02/20/investing-in-charthop/" target="_blank" rel="noopener noreferrer"><img src='/home/brand_logos/andreessen-logo.svg' alt="Andreessen Horowitz" /></a>
								<a className="p-xs-1 p-sm-1 m-xs-1 m-sm-1 p-2 " href="https://fortune.com/2020/02/20/three-mega-deals-to-have-on-your-radar-today/" target="_blank" rel="noopener noreferrer" ><img src='/home/brand_logos/fortune-logo.svg' alt="Fortune" /></a>
								<a className="p-xs-1 p-sm-1 m-xs-1 m-sm-1 p-2 " href="https://www.axios.com/newsletters/axios-pro-rata-d44f1859-d40e-42dc-aa9c-45d12e9a0e5f.html?utm_source=newsletter&utm_medium=email&utm_campaign=newsletter_axiosprorata&stream=top" target="_blank" rel="noopener noreferrer"><img src='/home/brand_logos/axios-logo.svg' alt="Axios" /></a>
								<a className="p-xs-1 p-sm-1 m-xs-1 m-sm-1 p-2 wsjAnchor" href="https://www.businessinsider.com/future-of-work-startups-success-year-venture-capital-2020-4" target="_blank" rel="noopener noreferrer"><img src='/home/brand_logos/businessinsider-logo.svg' alt="Business Insider" className="wsj" /></a>
								<a className="p-xs-1 p-sm-1 m-xs-1 m-sm-1 p-2 " href="https://www.shrm.org/ResourcesAndTools/hr-topics/talent-acquisition/Pages/Tips-and-Tools-Engage-Your-Remote-Workers.aspx" target="_blank" rel="noopener noreferrer"><img src='/home/brand_logos/shrm-logo.svg' alt="SHRM" /></a>
								<a className="p-xs-1 p-sm-1 m-xs-1 m-sm-1 p-2 wsjAnchor" href="https://venturecapital.cmail20.com/t/ViewEmail/d/81CF001325B5D5022540EF23F30FEDED/34C424D6E7F093C3405DC10595964AA8" target="_blank" rel="noopener noreferrer"><img src='/home/brand_logos/wsj-logo.svg' alt="The Wall Street Journal" className="wsj" /></a>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* YOUR FOCUS */}
			<section className="backgroundGradientContainer">
				<div className="container pt-3 pb-3 pt-md-6 pb-md-6">
					<div className="row align-items-center">

						<div className="col-md-8 col-lg-6 offset-lg-1 ">
							<h2 className="mb-2">You focus on your customer. We'll focus on keeping their data safe.</h2>
							<p>ChartHop has best-in-class security controls so you can feel confident your customer data is safe with us.</p>
							<div className="text-center d-block d-md-none d-block mr-auto ml-auto mt-4 mb-4">
								<img src='/home/safety.svg' alt="Safety" className="" width="195" />
							</div>
							<div className="container d-sm-flex">
								<ul className="col-md-6 pb-0 pr-3">
									<li>Complete SOC 2 Type 2 Examination</li>
									<li>Encryption at rest & in transit </li>
									<li>Biometric and physical-key two-factor access control</li>
								</ul>
								<ul className="col-md-6 pt-0 pr-3">
									<li>Mandatory SSO enforcement</li>
									<li>Employee auto-offboarding</li>
									<li>Customizable permission controls</li>
								</ul>
							</div>
						</div>

						<div className="reactPlayerContainer col-md-4 col-lg-3 offset-lg-1" >
							<img src='/home/safety.svg' alt="Safety" className="p-2 d-none d-md-block " />
						</div>
					</div>
				</div>
			</section>

			{/* REQUEST DEMO */}
			<section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
				<DemoFormLongNoSize source={"product-connect-demo-bottom"} headertext={HtmlParser('<h2>It&apos;s time to focus on what matters most - your product. </br></br> We can take care of the integrations.</h2>')}/>
			</section>
		</Layout>
	);
};


export default Home;


export const query = graphql`
  query {
    allTestimonialsJson {
      edges {
        node {
          id
          name
          title
          quote
		  image
		  logo
        }
      }
    }
  }
`;